import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { KeyboardDoubleArrowDown } from "@mui/icons-material";
import { useSelector } from "react-redux";
import * as FirestoreService from "../utils/firestoreQuery";
import "./ResultsFil.css";
import Background from "../assets/quiz-results-bg.png";

function ResultsFil() {
  const { score } = useSelector((state) => state.score);
  const [pic1, setPic1] = useState();
  const [num, setNumber] = useState();

  useEffect(() => {
    window.scrollTo(0, 0);
    setNumber(score);

    FirestoreService.getQuizVideos().onSnapshot((doc) => {
      setPic1(doc.data().quizPics.pic1);
    });
  }, [num]);

  const handleTools = () => {
    window.location.replace("https://aralplus.ph/quick-learning-tools");
  };

  const handleChoice = () => {
    window.location.replace("https://aralplus.ph/choice-module");
  };

  const handleVids = () => {
    window.location.replace("https://aralplus.ph");
  };

  return (
    <Box className="main-result-card">
      <Box className="bg-container">
        <img src={Background} alt="BG" className="bg-img" />
      </Box>
      <Box className="text-container">
        <p className="header-text" style={{ marginTop: "20rem" }}>
          Congratulations!
        </p>
      </Box>
      <Box className="text-container">
        <p className="header-text-2">
          Kung ang iyong sagot ay Oo sa lahat o karamihan sa mga tanong, may
          mataas kang level of empowerment bilang isang kostumer!
        </p>
      </Box>
      <Box className="text-container-2">
        <p className="header-text-2">
          Ang mga tanong na hindi mo nasagot ay nagpapahiwatig ng mga aspetong
          maaari mong pagbutihin tungo sa pagtaas ng level of empowerment.
        </p>
      </Box>
      <Box sx={{ textAlign: "center", marginTop: "3rem", opacity: "0.3" }}>
        <h1>Mag-scroll pababa para sa iba pa</h1>
        <KeyboardDoubleArrowDown sx={{ fontSize: "2rem", fontWeight: "500" }} />
      </Box>
      <Box className="table-card">
        <Box className="table-text-container">
          <p className="p-text">
            Makikita sa ibaba ay ang Customer Empowerment Grid, na nagpapakita
            ng mga katangian ng isang empowered kostumer mula sa iba't ibang
            elemento: Kaalaman at Kasanayan, Pananaw at Kumpyansa, at Pag-uugali
            at Karanasan, sa apat na dimensyon: Pagpili, Boses, Paggalang, at
            Kontrol.
          </p>
        </Box>
        <Box className="table-container">
          <Box className="table-image-container">
            <img src={pic1} className="table-img" alt="table" />
          </Box>
        </Box>
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        <Box className="text-container">
          <p className="header-text-2" style={{ width: "600px" }}>
            Tingnan pa mga ang sumusunod upang makatulong sa iyo na mapabuti ang
            iyong level of empowerment sa dimensyon ng pagpili:
          </p>
        </Box>
        <Box className="text-container-2">
          <p className="link-text" onClick={() => handleChoice()}>
            Modyul sa Pagpili
          </p>
        </Box>
        <Box className="text-container-2">
          <p className="link-text" onClick={() => handleVids()}>
            Mga Bidyo ng Empowered Filipino Customer
          </p>
        </Box>
        <Box className="text-container-2" sx={{ marginBottom: "5rem" }}>
          <p className="link-text" onClick={() => handleTools()}>
            Iba Pang Quick Learning Tools
          </p>
        </Box>
      </Box>
    </Box>
  );
}

export default ResultsFil;
